import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import eyeVisible from '../images/eye-visible.svg';
import eyeInvisible from '../images/eye-invisible.svg';

type PasswordInputProps = {
    value: string,
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void,
    onBlur: (e: React.FocusEvent<HTMLInputElement>) => void,
    name: string,
    placeholder?: string,
    isInvalid: boolean,
}

export default function PasswordInput({ value, onChange, onBlur, name, placeholder, isInvalid } : PasswordInputProps) {
    const [typePassword, setTypePassword] = useState('password');
    const [passwordIcon, setPasswordIcon] = useState(eyeVisible);

    const typePasswordHandler = () => {
        if (typePassword === 'password') {
            setTypePassword('text');
            setPasswordIcon(eyeInvisible);
        } else {
            setTypePassword('password');
            setPasswordIcon(eyeVisible);
        }
    }

    return (
        <div className="input-password">
            <Form.Control type={typePassword} className="form-control" placeholder={placeholder} onChange={onChange} onBlur={onBlur} name={name} isInvalid={isInvalid}/>
            <img src={passwordIcon} onClick={typePasswordHandler} className='toggle' alt=""/>
        </div>
    )
}